import groupLinks from './groupLinks';

export default groupLinks;
